// Firebase 9
import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import { getFirestore, doc, setDoc } from 'firebase/firestore'

const config = {
  apiKey: "AIzaSyC3MDkjDo-Cd0ylWB31xWtrVT1eXarXgVU",
  authDomain: "marvel-quizz-6144d.firebaseapp.com",
  projectId: "marvel-quizz-6144d",
  storageBucket: "marvel-quizz-6144d.appspot.com",
  messagingSenderId: "526139638314",
  appId: "1:526139638314:web:0ff9d605af891fd7483953"
};

const app = initializeApp(config);
export const auth = getAuth(app);

export const firestore = getFirestore();

export const user = uid => doc(firestore, `users/${uid}`);


